import React from 'react';
import PropTypes from 'prop-types';

import TransactionKey from "../Display/TransactionKey";

import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import Percentage from "components/Display/Percentage";



class CollectionFee extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      highlight : props.highligh
    }
  };


  render() {
    let collectionFee = this.props.data;
    let shouldHighlightClass = (this.state.highlight ? "calc-setting-table calc-setting-table-highlight" : "calc-setting-table" );
    return (
        <div className={shouldHighlightClass}>
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <tbody>
          <tr>
            <th className="text-right">Gildir frá</th>
            <td className="text-right"><Date data={collectionFee.validFromDate}/></td>
            <th className="text-right">&nbsp;</th>
            <td className="text-right">&nbsp;</td>
            <th className="text-right">&nbsp;</th>
          </tr>
          <tr>
            <th className="text-right">Grunngjald</th>
            <td className="text-right"><Amount data={collectionFee.collectionBaseFee}/></td>
            <th className="text-right">Færslulykill</th>
            <td className="text-right">
              <TransactionKey data={collectionFee.transactionKey}/>
            </td>
          </tr>

          <tr>
            <th colSpan="5" className="text-left">Innheimtustig:</th>
          </tr>
          <tr>
            <th colSpan="2" className="text-left">Prósenta eða krónutala</th>
            <th className="text-right">Upphæð</th>
            <th colSpan="2" className="text-left">&nbsp;</th>
          </tr>

          {collectionFee.collectionFeeIncrementals.map(function(item,i){
            return(
              <tr key={i}>
                <td className="text-right"><Percentage data={item.percentage}/></td>
                <td className="text-right"><Amount data={item.pointAmount}/></td>
                <td className="text-right"><Amount data={item.amount}/></td>
                <td className="text-right">&nbsp;</td>
                <td className="text-right">&nbsp;</td>
              </tr>);
          })}
          <tr className="calc-setting-table-splitline">
            <td  colSpan="5">&nbsp;</td>
          </tr>
          </tbody>
        </table>


      </div>
    );
  }
}

CollectionFee.propTypes = {
  data : PropTypes.object,
  highligh : PropTypes.bool
};



export default CollectionFee;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/CollectionFee.js